import React from 'react';
import { styled } from 'linaria/react';
import { theme } from '../../Theme';

const JournalNavigationWrapper = styled('nav')`
  display: flex;
  margin-bottom: 40px;
  margin-top: 20px;

  ${theme.below.lg} {
    padding: 0 20px;
    margin: 17px 0;
    overflow-x: scroll;
    ::-webkit-scrollbar {
      display: none;
    }
    -ms-overflow-style: none; /* IE and Edge */
    scrollbar-width: none; /* Firefox */
  }
`;

const JournalNavigationItem = styled('div')`
  padding: 13px 30px;
  background: ${theme.colors.grey};
  color: ${theme.colors.darkgrey};
  margin-right: 10px;
  font-weight: 700;
  font-size: 12px;
  line-height: 17px;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  text-decoration: none;
  cursor: pointer;
  border-radius: ${theme.button.desktop.borderRadius};

  &.active {
    background: ${theme.colors.accent};
    color: ${theme.colors.accentTextColor};
  }

  ${theme.below.lg} {
    width: 100%;
    min-width: fit-content;
  }
`;

export const JournalNavigation = ({
  subCategories,
  activeSubCategory,
  setActiveSubCategory
}) => {
  return (
    <JournalNavigationWrapper>
      <JournalNavigationItem
        className={activeSubCategory === 'all' && 'active'}
        onClick={() => setActiveSubCategory('all')}
      >
        allt
      </JournalNavigationItem>
      {subCategories?.map(subCategory => {
        return (
          subCategory?.hasSubcategories && (
            <JournalNavigationItem
              className={activeSubCategory === subCategory?.name && 'active'}
              onClick={() => setActiveSubCategory(subCategory?.name)}
            >
              {subCategory?.name}
            </JournalNavigationItem>
          )
        );
      })}
    </JournalNavigationWrapper>
  );
};
